import { render, staticRenderFns } from "./DimensionExtItem.vue?vue&type=template&id=5749f070&scoped=true"
import script from "./DimensionExtItem.vue?vue&type=script&lang=js"
export * from "./DimensionExtItem.vue?vue&type=script&lang=js"
import style0 from "./DimensionExtItem.vue?vue&type=style&index=0&id=5749f070&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5749f070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5749f070')) {
      api.createRecord('5749f070', component.options)
    } else {
      api.reload('5749f070', component.options)
    }
    module.hot.accept("./DimensionExtItem.vue?vue&type=template&id=5749f070&scoped=true", function () {
      api.rerender('5749f070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/dragItem/DimensionExtItem.vue"
export default component.exports